import React, { useCallback, useState } from 'react';
import loginLogo from '../../assets/img/PassPlay_Landscape_Transparent.png';
import styles from '../login/login.module.css';
import { Text, Button } from '@nike/eds';
import { useNavigate } from 'react-router-dom';
import { useI18nContext } from '../../context/language/use-i18n-context';
import ts from './i18n';
import AthleteLogin from './athlete_login/athlete-login';
import { useOktaAuth } from '@okta/okta-react';

interface LoginProps {
  isNetworkError?: boolean;
}

export const Login: React.FC<LoginProps> = ({ isNetworkError = false }) => {
  const [loginType, setLoginType] = useState<'okta' | 'athlete'>('okta');
  const navigate = useNavigate();
  const { i18nString } = useI18nContext();
  const oktaAuthInstance = useOktaAuth();

  const handleLogin = () => {
    oktaAuthInstance.oktaAuth.signInWithRedirect();
  };

  const handleRedirection = (route: string) => {
    navigate(route);
  };

  const handleLoginTypeChange = useCallback(async (type: 'okta' | 'athlete') => {
    setLoginType(type);
  }, []);

  return (
    <>
      {isNetworkError && (
        <h1 className={styles.login_error}>
          <center> THERE HAS BEEN AN ERROR - ENSURE YOU ARE CONNECTED TO NIKE NETWORK </center>
        </h1>
      )}
      <div className="eds-flex eds-flex--justify-content-center eds-flex--align-items-center">
        <img className={styles.login_img} alt="passplay logo" src={loginLogo}></img>
      </div>
      <hr></hr>
      {loginType === 'okta' && (
        <>
          <Text as={'h2'} className={`${styles.login_text} h2_font`}>
            {i18nString(ts.LOG_INTO_PASS_PLAY)}
          </Text>
          <Text className={styles.login_txt}>{i18nString(ts.LOGIN_MAIN_TEXT)}</Text>
          <div>
            <div className={styles.login_div}>
              <Button
                size="medium"
                variant="primary"
                onClick={() => handleLogin()}
                className={styles.login_nike_btn}
              >
                {i18nString(ts.LOGIN_NTLM_BUTTON)}
              </Button>
            </div>
            <div className={styles.divider}>
              <strong className={styles.divider_title}>or</strong>
            </div>
            <div className={styles.login_div}>
              <Button
                size="medium"
                variant="primary"
                onClick={() => handleLoginTypeChange('athlete')}
                className={styles.login_athlt_btn}
              >
                {' '}
                {i18nString(ts.LOGIN_ATHLETE_BUTTON)}
              </Button>
            </div>
          </div>
        </>
      )}
      {loginType === 'athlete' && (
        <AthleteLogin
          onLoginTypeChange={handleLoginTypeChange}
          onSuccessfulLogin={handleRedirection}
        />
      )}
    </>
  );
};
